import { Link } from "react-router-dom";

/**
 * Lateral navigation between the three crawl-scoped views:
 *   - Map       (/crawls/:id)
 *   - Intents   (/crawls/:id/intents)
 *   - Tests     (/crawls/:id/tests)
 *
 * Rendered identically on each of the target pages so users can move
 * between them without hopping back to the dashboard. Keeps styling + DOM
 * in one place so changes propagate everywhere.
 */
export type CrawlTab = "map" | "intents" | "tests";

export function CrawlTabs({
  crawlId,
  active,
}: {
  crawlId: string;
  active: CrawlTab;
}): JSX.Element {
  const encoded = encodeURIComponent(crawlId);
  const tabs: { key: CrawlTab; label: string; to: string }[] = [
    { key: "map", label: "Map", to: `/crawls/${encoded}` },
    { key: "intents", label: "Intents", to: `/crawls/${encoded}/intents` },
    { key: "tests", label: "Tests", to: `/crawls/${encoded}/tests` },
  ];
  return (
    <nav className="mb-6 flex items-center gap-1 border-b border-slate-800">
      {tabs.map((t) => {
        const isActive = t.key === active;
        return (
          <Link
            key={t.key}
            to={t.to}
            className={`px-4 py-2 text-sm border-b-2 -mb-px transition ${
              isActive
                ? "border-indigo-400 text-slate-100"
                : "border-transparent text-slate-400 hover:text-slate-200"
            }`}
          >
            {t.label}
          </Link>
        );
      })}
    </nav>
  );
}
